import { createError } from './helpers/createError';

export const AbortError = createError('AbortError');
